import { FilterNearBy, PriceRange, Room } from 'app/services/products/payload/product-nearby-payload';
import { ProductReviewModel } from './product-review.model';

export class ProductNearByDTO {
    langId: String;
    address: String;
    currencyId: Number;
    destinationId: Number;
    productId: Number;
    imageUrl: String;
    productTitle: String;
    hotelStar: Number;
    latitude: Number;
    longitude: Number;
    radius: Number;
    netPrice: Number;
    priceRange: PriceRange;
    checkIn: string;
    checkOut: string;
    rooms: Room[];
    reviewRating: ProductReviewModel;
    slug: String;
}


// WEBPACK FOOTER //
// ./src/app/model/products/product-nearby-dto.model.ts